import { useAction, useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'

import { reatomInstantTradeButtonsForm } from '../atoms/reatom-instant-buttons-form'
import { instantBuyQuickOptionsAtom } from '../atoms/reatom-instant-buy'

import { InstantTradeQuickOptionsEditButton } from './instant-trade-buttons-edit-button'
import { InstantTradeQuickOptionInput } from './instant-trade-quick-option-input'

type TokenCreateFormProps = {
  onDone: () => void
}

export const InstantTradeBuyButtonsForm: React.FC<TokenCreateFormProps> = (
  props,
) => {
  const [instantBuyQuickOptions] = useAtom(instantBuyQuickOptionsAtom, [])

  const { instantSellButtonsFormState, buyInputs } = useMemo(
    () =>
      reatomInstantTradeButtonsForm({
        buyButtons: instantBuyQuickOptions,
        sellButtons: undefined,
      }),
    [instantBuyQuickOptions],
  )
  const [first] = useAtom(buyInputs![0].raw)
  const setFirst = useAction(buyInputs![0].setRaw)
  const [second] = useAtom(buyInputs![1].raw)
  const setSecond = useAction(buyInputs![1].setRaw)
  const [third] = useAtom(buyInputs![2].raw)
  const setThird = useAction(buyInputs![2].setRaw)
  const [fourth] = useAtom(buyInputs![3].raw)
  const setFourth = useAction(buyInputs![3].setRaw)

  const [formRequestState] = useAtom(instantSellButtonsFormState)
  const execute = useAction(instantSellButtonsFormState.execute)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await execute()

    props.onDone()
  }

  return (
    <Root>
      <Form onSubmit={handleSubmit}>
        <InstantTradeQuickOptionsEditButton
          type="submit"
          state={formRequestState.loading ? 'loading' : 'save'}
        />
        <InstantTradeQuickOptionInput
          size="s"
          mode="number"
          disabled={formRequestState.loading}
          value={first.toString()}
          onChange={setFirst}
          css={css`
            --input-height: 30px;
            --input-border: 1px solid var(--background-4);
            --input-border-active: 1px solid var(--background-6);
          `}
        />

        <InstantTradeQuickOptionInput
          size="s"
          mode="number"
          disabled={formRequestState.loading}
          value={second.toString()}
          onChange={setSecond}
          css={css`
            --input-height: 30px;
            --input-border: 1px solid var(--background-4);
            --input-border-active: 1px solid var(--background-6);
          `}
        />

        <InstantTradeQuickOptionInput
          size="s"
          mode="number"
          disabled={formRequestState.loading}
          value={third.toString()}
          onChange={setThird}
          css={css`
            --input-height: 30px;
            --input-border: 1px solid var(--background-4);
            --input-border-active: 1px solid var(--background-6);
          `}
        />

        <InstantTradeQuickOptionInput
          size="s"
          mode="number"
          disabled={formRequestState.loading}
          value={fourth.toString()}
          onChange={setFourth}
          css={css`
            --input-height: 30px;
            --input-border: 1px solid var(--background-4);
            --input-border-active: 1px solid var(--background-6);
          `}
        />
      </Form>
    </Root>
  )
}

const Root = styled.div``
const Form = styled.form`
  display: grid;
  grid-template-columns: 30px 1fr 1fr 1fr 1fr;
  gap: 2px;
  flex-direction: row;
`
